import { axiosInstance } from '@configs/axios/axiosInstance';

import type { SfAccount } from '../types/sfRedirect.types';

/**
 * Import/onboard a Salesforce account into CAE Connect
 * Endpoint: POST /sf-redirect/accounts/{sfAccountId}/import
 *
 * Returns the SfAccount with `isOnboarded: true` on success.
 */
export async function importSfAccount(sfAccountId: string): Promise<SfAccount> {
  const { data } = await axiosInstance.post<SfAccount>(
    `/sf-redirect/accounts/${encodeURIComponent(sfAccountId)}/import`
  );
  return data;
}
